/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_OccurredInputs */

const en_error_occurred = /** @type {(inputs: Error_OccurredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred`)
};

const nl_error_occurred = /** @type {(inputs: Error_OccurredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Er is een fout opgetreden`)
};

/**
* | output |
* | --- |
* | "An error occurred" |
*
* @param {Error_OccurredInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const error_occurred = /** @type {((inputs?: Error_OccurredInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_OccurredInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_error_occurred(inputs)
	return en_error_occurred(inputs)
});